/* eslint-disable jsx-a11y/anchor-is-valid */
import {FC, useEffect, useMemo} from 'react'
import { MenuComponent } from '../../../../../../_metronic/assets/ts/components'
import { KTSVG } from '../../../../../../_metronic/helpers'
import { DLMSiteApplication, DLM_APPLICANT_RESPOND_STATES, DLM_END_STATES, DLM_NO_TERMINATE_STATES, useDLMApplicationView } from '../../../../core/doclabel'
import { useDLMSiteApplicationsListContext } from '../../../../core/doclabel/components/sites-list/components'
import { useAuth } from '../../../../auth'
import { cloneDeep } from 'lodash'
type Props = {
  site: DLMSiteApplication 
}

const DLMSiteApplicationsApplicantActionsCell: FC<Props> = ({site}) => {

    const {dlmAppData} = useDLMApplicationView();

    const { setCurrentSite, setItemIDForDelete, setItemIDForUpdate, applicationOwnerId, setResubmitData } = useDLMSiteApplicationsListContext();
    const { currentUser } = useAuth();
   
    const { canRespond, responseTitle, canTerminate, canTerminateCancel, canTerminateReply, canResubmit } = useMemo(() => {

        if (! site) return { canRespond : false, responseTitle: '', canTerminate: false, canTerminateCancel: false, canTerminateReply: false, canResubmit: false};
        let responseTitle = "Respond";
        
        const { state, requestTerminateState } = site;
        
        const canResubmit: boolean = (state === 'Admin Review - Issue') ? true : false;       

        const canRespond: boolean = (DLM_APPLICANT_RESPOND_STATES.includes(state));        

        const canTerminate = (
            (! DLM_END_STATES.includes(state))
            && (! DLM_NO_TERMINATE_STATES.includes(state))
            && (! (requestTerminateState && (requestTerminateState === 'REQUEST_TERMINATE_APPLICATION' || requestTerminateState === 'REQUEST_TERMINATE_APPLICATION_REPLY')))
            && (currentUser && (
                currentUser.role === 'Management' || applicationOwnerId === currentUser.id
            ))
        );

        const canTerminateCancel: boolean = (            
          (requestTerminateState !== undefined) && 
          (requestTerminateState === 'REQUEST_TERMINATE_APPLICATION' || requestTerminateState === 'REQUEST_TERMINATE_APPLICATION_REPLY')                
        );

        const canTerminateReply = (requestTerminateState && requestTerminateState === 'REQUEST_TERMINATE_APPLICATION_REPLY') ? true : false;

        switch(state) {
            case 'Admin Review - Issue':             
                responseTitle = 'Resubmit';
                break;
            case 'Applicant Confirmation':
                responseTitle = 'Confirm ROI';                
                break;
            case 'Pending Inspection':
                responseTitle = 'Submit Inspection Details';            
                break;
            case 'Applicant Sign':
                responseTitle = 'Endorse ROI';                
                break;
            default: 
                responseTitle = 'Submit Response';
                break;
        }        
        
        return { canRespond, responseTitle, canTerminate, canTerminateCancel, canTerminateReply, canResubmit };
    }, [site, applicationOwnerId, currentUser]);

    const doResubmit = () => {
        let site_labels = 0;                                        
        if (site.hasOwnProperty('siteApplicationDetails') && site.siteApplicationDetails.length > 0) {            
            site.siteApplicationDetails.forEach(_item => {
                if (_item?.quantity && _item.quantity > 0) {
                    site_labels += parseInt(`${_item.quantity}`);                                                
                }
            })
        }                    

        // @ts-ignore
        setResubmitData({ 
            ...cloneDeep(dlmAppData),             
            siteApplications: [ site ], 
            totalLabelQuantity: site_labels 
        });       
    }

    useEffect(() => {
        if (canRespond || canTerminate || canTerminateCancel || canTerminateReply) {
            MenuComponent.reinitialization()
        }
    }, [canRespond, canTerminate, canTerminateCancel, canTerminateReply])

    
    if (! (canRespond || canTerminate || canTerminateCancel || canTerminateReply)) {
        return null;
    }
    
    return (
    <div className="align-top">
    <a        
        className='btn btn-light btn-active-light-primary btn-sm'
        data-kt-menu-trigger='click'
        data-kt-menu-placement='bottom-start'
    >
        Actions
        <KTSVG path='/media/icons/duotune/arrows/arr072.svg' className='svg-icon-5 m-0' />
    </a>
      
    <div
        className='menu menu-sub menu-sub-dropdown menu-column menu-rounded menu-gray-600 menu-state-bg-light-primary fw-bold fs-7 py-4 mw-125px'
        data-kt-menu='true'
    >        

        { canResubmit && 
        <div className='menu-item px-3'>
            <a className='menu-link px-3' onClick={() => { doResubmit() }}>
                {responseTitle}
            </a>
        </div>         
        }        
        { canRespond && 
        <div className='menu-item px-3'>
            <a className='menu-link px-3' onClick={() => { setCurrentSite(site) }}>
                {responseTitle}
            </a>
        </div>         
        }
        { canTerminate && 
        <div className='menu-item px-3 text-start' title="Terminate Site Application">
            <a className='menu-link px-3 text-hover-danger' onClick={() => setItemIDForDelete(site.id)}>
                Terminate
            </a>
        </div> 
        }
        { canTerminateCancel && 
        <div className='menu-item px-3 text-start' title="Cancel Terminate Site Application">
            <a className='menu-link px-3 text-hover-danger' onClick={() => setItemIDForDelete(site.id)}>
                Cancel Terminate
            </a>
        </div> 
        }
        { canTerminateReply && 
        <div className='menu-item px-3 text-start' title="Respond to Termination RFI">
            <a className='menu-link px-3 text-hover-danger' onClick={() => setItemIDForUpdate(site.id)}>
              Respond to Termination RFI
            </a>
        </div> 
        }
    </div>    
    </div>
  )
}

export {DLMSiteApplicationsApplicantActionsCell}
